export const invalidJWTError = 'Invalid JWT token';
